<template>

  <div class="modal" id="deleteBoxModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border border-warning">
      <div  class="modal-header bg-warning border border-warning">       
        <h4 class="modal-title"><strong>
          <i style="color:black" class="fas fa-trash mr-3" aria-hidden="true"></i>   
          ELIMINA COUPON  {{couponId}}</strong> </h4>       
      </div>
      <div class="modal-body">
        <p>            
            <!--<i style="color:blue;font-size:20px" class="fas fa-exclamation-triangle mr-3" aria-hidden="true"></i>-->
           <STRONG>PROCEDO ?</STRONG>  </p>
      </div>
      <div class="modal-footer">
        <button type="button" @click="closeModal()" class="btn btn-secondary">NO</button>
        <button @click="deleteItem()" type="button" class="btn btn-primary">SI</button>
        
      </div>
    </div>
  </div>
  </div>
  
</template>
<script>
    
export default {
  props : ['couponId'],
 
  components: {
    
  
  },
  data () 
  {
    return {
     
    }
  },
    computed: 
  {
    //...mapGetters(['storeId','company']) , 
  },
  created: function()
  {
    this.$nextTick(()  => {                  
        $('#deleteBoxModal').modal('show')
    
    })  
  },
  methods :
  {
    closeModal()
    {
      $('#deleteBoxModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },  
    deleteItem()
    {
      $('#deleteBoxModal').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('delete')
      })     
     
    }
  }
}
</script>    
<style scoped>
h4{
  font-size: 20px;
}
.modal-footer {  
  justify-content: space-between;  
}

</style>
